import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const jobRestUrl = authorizationServicesPath + '/organizations/addresses'

export default class AddressOrganizationService {

    static async getAll() {
        return axios.get(jobRestUrl);
    }

    static async update(data, id) {
        return await axios.put(jobRestUrl + "/" + id,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(jobRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(data) {
        return await axios.post(jobRestUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}